import Select, { SelectOption } from '@amzn/meridian/select';
import React, { FC } from 'react';
import { SearchableExtractionFields } from '../../../redux/types';
import { SearchField, TFunction } from '../../blocks';

export const SEARCH_BY_TEST_ID = 'extractionSearchByFilter';
export const SEARCH_FIELD_TEST_ID = 'extractionSearchFieldFilter';

interface ExtractionSearchFilterProps {
    searchBy: SearchableExtractionFields;
    onSearchByChange: (value: SearchableExtractionFields) => void;
    query: string;
    onQueryChange: (value: string) => void;
    onSubmit: () => void;
    t: TFunction;
}

const labelKeyForField = (field: SearchableExtractionFields): string => {
    switch (field) {
        case SearchableExtractionFields.fileName:
            return 'fileName-label';
        case SearchableExtractionFields.requestedBy:
            return 'requestedBy-label';
        default:
            return 'customerReference-label';
    }
};

const ExtractionSearchFilter: FC<ExtractionSearchFilterProps> = ({
    searchBy,
    onSearchByChange,
    query,
    onQueryChange,
    onSubmit,
    t,
}) => (
    <>
        <Select
            onChange={onSearchByChange}
            placeholder={t('common:search-by-text')}
            data-testid={SEARCH_BY_TEST_ID}
            size={'xlarge'}
        >
            <SelectOption value={SearchableExtractionFields.customerReference} label={t('customerReference-label')} />
            <SelectOption value={SearchableExtractionFields.fileName} label={t('fileName-label')} />
            <SelectOption value={SearchableExtractionFields.requestedBy} label={t('requestedBy-label')} />
        </Select>
        <SearchField
            value={query}
            onChange={onQueryChange}
            onSubmit={onSubmit}
            label={t(labelKeyForField(searchBy))}
            searchButton={false}
            data-testid={SEARCH_FIELD_TEST_ID}
        />
    </>
);

export default ExtractionSearchFilter;
